/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { Loading } from 'components';
import { Layout } from 'containers';
import { Login } from 'pages';
import { loginWithToken } from '../containers/App/slices';
import { RootState } from '../store';

const RootRouter = () => {
  const dispatch = useDispatch();
  const { isAuth } = useSelector((state: RootState) => state.app);
  useEffect(() => {
    if (localStorage['token']) {
      dispatch(loginWithToken());
    }
  }, [dispatch]);

  const RouteRender = useCallback(() => {
    if (isAuth || localStorage['token']) {
      return <Layout />;
    }
    return <Redirect to="/login" />;
  }, [isAuth, localStorage['token']]);

  return (
    <Suspense fallback={Loading}>
      <BrowserRouter>
        <Switch>
          <Route path="/login" component={Login} exact={true} />
          <Route path="/" render={RouteRender} />
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
};

export default RootRouter;
